import { useEffect, useState } from 'react';
import { useStore } from '../context/StoreContext';
import service from '../services/breadorders.service';

export function useBreadOrders(fetchAll = false) {
    const { activeStoreId } = useStore();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        service.fetchBreadsWithListeners(fetchAll, (data) => {
            setOrders(data);
            setLoading(false);
        });
        return () => service.unsubscribe();
    }, [fetchAll, activeStoreId]);

    return { orders, loading };
}
